import { PhoneNumber, PostalCode } from "@/@types/reservation";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import MemberService from "@/services/members";

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function deleteNullProp(obj: any, stringNull = false): any {
  if (obj["data_type"]) {
    delete obj["data_type"];
  }
  if (obj["id"]) {
    delete obj["id"];
  }
  if (obj["updated_at"]) {
    delete obj["updated_at"];
  }
  if (obj["created_at"]) {
    delete obj["created_at"];
  }
  for (const k in obj) {
    if (obj[k] === null) {
      delete obj[k];
    }
  }
  if (stringNull) {
    for (const k in obj) {
      if (obj[k] === "") {
        delete obj[k];
      }
    }
  }
  return obj;
}

export function parsePhoneNumber(phone: string): string {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const parsedNumber = phoneUtil.parse(phone, "JP");
  return phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL);
}

export function getPhoneNumber3(phone: string): PhoneNumber {
  const phoneNumber = phone;
  const number1 = phoneNumber.substring(0, phoneNumber.indexOf("-"));
  const replace1 = phoneNumber.replace(`${number1}-`, "");
  const number2 = replace1.substring(0, replace1.indexOf("-"));
  const replace2 = replace1.replace(`${number2}-`, "");
  const number3 = replace2;
  return { number1, number2, number3 };
}

export function getPostalCode2(code: string): PostalCode {
  const postalCode = code;
  const number1 = postalCode.substring(0, postalCode.indexOf("-"));
  const replace1 = postalCode.replace(`${number1}-`, "");
  const number2 = replace1;
  return { number1, number2 };
}

export const authCheck = async (id: string) => {
  const res = await MemberService.get(id);
  const me = res.data.data.length ? res.data.data[0] : undefined;
  if (me === undefined) {
    return false;
  }
  if (me.member_status === "member") {
    return true;
  } else {
    false;
  }
};

/**
 * forEach Promise化して実行
 *
 * @param array
 * @param callback
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function asyncForEach(array: any[], callback: any) {
  for (let index = 0; index < array.length; index += 1) {
    // eslint-disable-next-line no-await-in-loop
    await callback(array[index], index, array);
  }
}

/**
 *
 * map Promise化して実行
 * @param array
 * @param operation
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function asyncMap(array: any[], operation: any) {
  // eslint-disable-next-line no-return-await
  return Promise.all(array.map(async (item) => await operation(item)));
}
